"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = _interopRequireDefault(require("@tippyjs/react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["content", "children", "trigger", "size", "distance", "position"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var sizeClasses = {
  sm: 'tooltip_sm',
  md: '' // default size has no special class
};
var distanceClasses = {
  sm: 'tippy-box__distance_sm',
  md: '' // default distance has no special class
};
var Tooltip = exports.Tooltip = function Tooltip(_ref) {
  var content = _ref.content,
    children = _ref.children,
    trigger = _ref.trigger,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? 'md' : _ref$distance,
    position = _ref.position,
    tooltipProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var ref = (0, _react.useRef)(null);
  var tooltipClasses = (0, _classnames["default"])('tooltip', sizeClasses[size]);
  return /*#__PURE__*/_react["default"].createElement(_react2["default"], (0, _extends2["default"])({}, tooltipProps, {
    trigger: trigger,
    animation: "fade",
    placement: position,
    className: distanceClasses[distance],
    content: /*#__PURE__*/_react["default"].createElement("div", {
      className: tooltipClasses,
      "data-testid": "tooltip"
    }, content)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tippy-trigger",
    ref: ref
  }, children));
};

// is only needed to avoid snapshots updating
Tooltip.defaultProps = {
  size: 'md',
  distance: 'md'
};